<div class="title" mat-dialog-title>Add Username & Password</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You will need to contact your Nielsen Account Manager to obtain the details below</div>
        <form [formGroup]="connectionForm">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Nielsen Username</mat-label>
                <input matInput placeholder="Enter Nielsen Username" formControlName="username" data-cy="nielsen-username-input">
                <mat-error
                    *ngIf="connectionForm.get('username').errors && (connectionForm.get('username').touched || connectionForm.get('username').dirty)">
                    Invalid Username</mat-error>
                </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Nielsen Password</mat-label>
                <input type="password" matInput placeholder="Enter Nielsen Password" formControlName="password" data-cy="nielsen-password-input">
                <mat-error
                    *ngIf="connectionForm.get('password').errors && (connectionForm.get('password').touched || connectionForm.get('password').dirty)">
                    Invalid Password</mat-error>
                </mat-form-field>
        </form>
        <div class="template">
            <a href="https://rubii-images.s3.ap-southeast-2.amazonaws.com/templates/nielsen.xlsx"
                target="_blank" data-cy="nielsen-template-link">Download a sample report</a>
        </div>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()" data-cy="nielsen-dialog-connect-btn">
            Connect Data Source
        </button>
    </div>
</div>
